<template>
  <div class="addBank">
    <Header
      :title="title"
      :right-content="rightContent"
      @bankNotice="bankNotice"
    />
    <div id="content">
      <div
        v-if="bankType==1"
        class="prompt"
      ><img src="@/assets/images/template/a_top_remind.png"><span>为了您的资金安全，存款需要绑定至少一张银行卡。</span></div>
      <div
        v-else
        class="uploadList"
      >
        <ul>
          <li><span class="check">添加银行卡</span><span>上传证明文件</span><span>提交信息</span></li>
          <li>
            <em />
            <p class="ntn1 check" />
            <p />
            <p />
          </li>
        </ul>
      </div>
      <div
        id="layout"
        class="layout"
      >
        <div class="addBankCard">
          <p v-if="bankType==0||bankType==''">每位用户最多能绑定三张银行卡，且仅接受绑定账户本人之银行卡，若绑定非本人银行卡资金将无法到账，请谨慎提交银行卡信息。</p><img src="@/assets/images/bank/bg.png">
        </div>
        <div class="dv_list">
          <ul>
            <li>
              <div class="item"><span @click="cardholderPop">请添加{{ accountInfo.chineseName }}的银行卡<img src="@/assets/images/template/a_top_remind_1.png"></span><em @click="selectBank(1)">支持的银行卡</em></div>
            </li>
            <li @click="selectBank(0,'bankType')">
              <div class="item"><span>银行名称</span>
                <div class="moreItem">
                  <p>{{ bankInfo.name }}</p><img src="@/assets/images/template/a_top_return_r.png">
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <span>{{ bankInfo.name === '支付宝' ? '账号' : '卡号' }}</span>            
                <input
                  :value="bankInfo.number"
                  class="inputHook"
                  :placeholder="bankInfo.name === '支付宝' ? '请输入支付宝账号' : '请输入卡号'"
                  type="text"
                  @input="onBankInfoNumberInput"
                  @blur="blurBankNum(bankInfo.number)"
                >
              </div>
            </li>
            <li class="rightTxt">
              <div class="errMessage">{{ errBankMessage }}</div>
            </li>
            <li @click="selectCountry('countryType')">
              <div class="item"><span>银行国家</span>
                <div class="moreItem">
                  <p>{{ bankInfo.country }}</p><img src="@/assets/images/template/a_top_return_r.png">
                </div>
              </div>
            </li>
            <li @click="selectProvince('provinceType')">
              <div class="item"><span>银行省份(选填)</span>
                <div class="moreItem">
                  <p>{{ bankInfo.province }}</p><img src="@/assets/images/template/a_top_return_r.png">
                </div>
              </div>
            </li>
            <li @click="selectCity('cityType')">
              <div class="item"><span>银行地址(选填)</span>
                <div class="moreItem">
                  <p>{{ bankInfo.city }}</p><img src="@/assets/images/template/a_top_return_r.png">
                </div>
              </div>
            </li>
            <!-- <li><div class="item"><span>银行支行（选填）</span><input  @click="focusEvent" class="inputHook" placeholder="请输入支行名称" type="text" v-model="bankInfo.branchName"/></div></li> -->
            <li v-show="!isOptional()">
              <div class="item"><span>银行支行</span><input
                v-model="bankInfo.branchName"
                class="inputHook"
                placeholder="请输入支行名称"
                type="text"
                @focus="errMessage='请填写正确支行名称，否则无法绑定成功'"
                @focusout="errMessage=''"
              ></div>
            </li>
            <li v-if="bankType==1?bankCardFourElement:true">
              <div class="item"><span>预留手机号</span>
                <p>{{ user.mobilePhone }}</p>
              </div>
            </li>
            <li v-if="bankType==1?bankCardFourElement:true">
              <VerifyCode
                :this-page-type="pageType"
                :code="bankInfo.code"
                :phone="user.mobilePhone"
                :account-number="user.loginname"
                :code-type="codeType"
                @changeCode="changeCode"
              />
            </li>
          </ul>
        </div>
        <div class="errMessage">{{ errMessage }}</div>
        <div class="btnItem">
          <span
            v-sa="{'AddCards':{'PType':pageType=='app'?'app端':pageType=='trade'?'H5交易':'用户中心','AccountType':'真实账户','bank_name':bankInfo.name}}"
            class="submit"
            :class="(Utils.isNotEmpty(bankInfo.number)&&Utils.isNotEmpty(bankInfo.name)&&bankInfo.name!='请选择银行'&&Utils.isNotEmpty(bankInfo.country)&&((bankType == 0 || bankType == '')?Utils.isNotEmpty(bankInfo.code):bankCardFourElement?Utils.isNotEmpty(bankInfo.code):Utils.isEmpty(bankInfo.code))) && !(bankInfo.name.includes('工商银行') && bankInfo.province.includes('广东'))&& (isOptional() ? true : Utils.isNotEmpty(bankInfo.branchName))?'suc':''"
            @click="submit"
          >提交</span>
          <Chat />
        </div>
      </div>
    </div>
    <SelectWithSearch 
      v-if="showSelectWithSearch"
      :select-list="selectWithSearchList"
      :selected-key="bankCode"
      @cancel="hideSelectWithSearch"
      @confirm="confirmSelectWithSearch"
    />
    <selectBox
      v-if="show"
      :show="show"
      :type="type"
      :list="list"
      :code-list="codeList"
      @change="change"
      @cancel="cancel"
    />
    <!--身份信息不匹配-->
    <div
      v-if="isBankInfoErr"
      class="popFixed"
    >
      <div
        class="masking"
        @click="bankInfoErrPop"
      />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>{{ bankInfoErr }}</p>
        </div>
        <div class="btnCon only">
          <span
            v-if="bankInfoErrFlag==0"
            @click="bankInfoErrPop"
          >重新填写</span>
          <span
            v-if="bankInfoErrFlag==1"
            @click="flashpage"
          >刷新</span>
        </div>
      </div>
    </div>
    <!--支持银行卡列表-->
    <holdBankList
      v-if="isHoldBank"
      :show="isHoldBank"
      :bank-list="bankList"
      @cancel="closeHoldBankPop"
    />
    <!--绑卡须知-->
    <div
      v-if="bankPop"
      class="popFixed"
    >
      <div
        class="masking"
        @click="noticePop"
      />
      <div class="tcCon">
        <div class="item">
          <span>绑卡须知</span>
          <p class="txtLeft">填写的银行卡资料将会作为您取款的收款账户。收款账户必须为账户本人所有，银行卡号也须与账户登记时一直。填写完成后，请提供银行卡证明，经验证通过后方可作提款申请用。</p>
        </div>
        <div class="btnCon only">
          <span @click="noticePop">我知道了</span>
        </div>
      </div>
    </div>
    <!--持卡人说明-->
    <div
      v-if="isCardholderPop"
      class="popFixed"
    >
      <div
        class="masking"
        @click="cardholderPop"
      />
      <div class="tcCon">
        <div class="item">
          <span>持卡人说明</span>
          <p>为了保证账户资金安全，只能绑定认证用户本人的银行卡</p>
        </div>
        <div class="btnCon only">
          <span @click="cardholderPop">我知道了</span>
        </div>
      </div>
    </div>
    <!-- 工商銀行 + 廣東省提示 -->
    <div
      v-if="showWarningPop"
      class="popFixed"
    >
      <div
        class="masking"
        @click="closeWarningPop"
      />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p class="txtLeft">请绑定其他银行银行卡， 以便资金快速到账。</p>
        </div>
        <div class="btnCon only">
          <span @click="closeWarningPop">我知道了</span>
        </div>
      </div>
    </div>
     <!-- 工商銀行 + 其他城市提示 -->
     <div
      v-if="showWarningOtherCitiesPop"
      class="popFixed"
    >
      <div
        class="masking"
        @click="closeShowWarningOtherCitiesPop"
      />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p class="txtLeft">如绑定工行出金, 取款时间将可能会延长, 且存款方式会较少。建议使用非工行出金, 出入金会更顺畅。</p>
        </div>
        <div class="btnCon only">
          <span @click="closeShowWarningOtherCitiesPop">我知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/addBank.css')
import Header from '@/view/module/Header.vue'
import VerifyCode from '@/view/module/VerifyCode.vue'
import selectBox from '@/view/bankCard/select.vue'
import Chat from '@/view/module/Chat.vue'
import holdBankList from '@/view/bankCard/holdBankList.vue'
import utils from '@/utils/tradeDataUtil'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import SelectWithSearch from '@/view/bankCard/SelectWithSearch.vue'

export default {
  name: 'AddBankCard',
  components: { Header, VerifyCode, selectBox, Chat, holdBankList, SelectWithSearch },
  data() {
    const u = navigator.userAgent
    return {
      title: '添加银行卡',
      isRecharge: false,
      Utils: utils,
      bankType: this.$route.query.bankType || '', // 提现：0，存款：1
      bankInfo: {
        number: '',
        name: '请选择银行',
        country: '中国',
        province: '北京',
        city: '北京市',
        branchName: '',
        code: ''
      },
      show: false,
      showSelectWithSearch: false,
      selectWithSearchList: [],
      list: '',
      codeList: '',
      bankList: '', // 银行名称列表
      bankCode: '', // 银行code
      bankOrder: '', // 银行卡序号
      bankLogoList: process.env.VUE_APP_BANKLOGO,
      logoList: [],
      countryCode: 'ISO_3166_156', // 国家code
      provinceCode: 'beijing', // 省code
      cityCode: 'beijing_C0001', // 市code
      type: '',
      isBankInfoErr: false,
      bankInfoErr: '',
      bankInfoErrFlag: '',
      codeType: 'bindBCVerifyCode',
      isHoldBank: false,
      bankPop: false,
      egpayBankCode: '',
      rightContent: 'problem',
      verifyThreeElement: '', // 是否需要三元素验证
      bankCardFourElement: '', // 银行卡四要素
      errBankMessage: '',
      errMessage: '',
      isCardholderPop: false,
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      showWarningPop: false,
      showWarningOtherCitiesPop:false
    }
  },
  computed: {
    ...mapState(['user', 'pageType', 'token', 'accountInfo']),
    verifyBankParam: {
      get() {
        return {
          bankAccountNumber: this.bankInfo.number,
          bankCode: this.bankCode,
          mobilephone: this.user.mobilePhone,
          isControlled: this.bankType != 0
        }
      }
    },
    bankParam: {
      get() {
        if (this.bankType == 1) {
          return {
            bank: this.bankCode,
            bankAccountNumber: this.bankInfo.number,
            code: this.bankCardFourElement ? this.bankInfo.code : '',
            bankCountry: this.countryCode,
            bankProvince: this.provinceCode,
            bankCity: this.cityCode,
            bankBranch: this.bankInfo.branchName
          }
        } else {
          return {
            bank: this.bankCode,
            bankAccountNumber: this.bankInfo.number,
            code: this.bankInfo.code,
            bankCountry: this.countryCode,
            bankProvince: this.provinceCode,
            bankCity: this.cityCode,
            bankBranch: this.bankInfo.branchName,
            bankOrder: this.bankOrder
          }
        }
      }
    }
  },
  watch: {
    // This runs automatically whenever bankInfo.name changes value
    'bankInfo.name': function(newVal, oldVal) {
      this.bankInfo.number = ''
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.LabelAuthority()
    if (this.bankType == 0 || this.bankType == '') this.withdrawBankList()
    this.getCountry()
    if (this.pageType == 'app') {
      this.autofocus()
      this.focusEvent()
    }
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    if (this.pageType == 'app') this.autofocus()
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    focusEvent() {
      document.addEventListener('focusin', function() {
        document.getElementById('layout').style.paddingBottom = '3.39rem'
      })
      document.addEventListener('focusout', function() {
        document.getElementById('layout').style.paddingBottom = '0'
      })
    },
    setForeBase() {
      this.$fireBase.logEvent('add_cards', {
        'platform_type': this.thisPageType == 'app' ? 'app端' : this.thisPageType == 'trade' ? 'H5交易' : '用户中心',
        'account_type': '真实账户',
        'source': this.title,
        'bank_name': this.bankInfo.name,
        'bank_country': this.bankInfo.country,
        'bank_province': this.bankInfo.province,
        'bank_city': this.bankInfo.city,
        'time': utils.getThisTime(),
        'url': window.location.href
      })
    },
    autofocus() {
      const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      // 软键盘弹出的事件处理
      document.body.addEventListener('focusin', () => {
        if (isIOS) {
          window.scrollTo(0, 0)
        }
      })
      // 软键盘收起的事件处理
      document.body.addEventListener('focusout', () => {
        if (isIOS) {
          window.scrollTo(0, 0)
        }
      })
    },
    bankNotice(data) {
      this.bankPop = data
    },
    cardholderPop() {
      this.toggleFixed()
      this.isCardholderPop = !this.isCardholderPop
    },
    noticePop() {
      this.toggleFixed()
      this.bankPop = !this.bankPop
    },
    bankInfoErrPop() {
      this.toggleFixed()
      this.isBankInfoErr = !this.bankInfoErr
    },
    closeWarningPop() {
      this.showWarningPop = false
    },    
    closeShowWarningOtherCitiesPop() {
      this.showWarningOtherCitiesPop = false
    },
    flashpage() {
      this.$router.go(0)
    },
    changeCode(code) {
      this.bankInfo.code = code
    },
    blurBankNum(number) {
      if (this.bankType == 0) this.getBankAcc(number)
      else this.getBankName(number)
    },
    getBankAcc(number) {
      const data = { bankAccountNumber: number }
      api.checkDuBankAccNumber(this.$qs.stringify(data)).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data) this.errBankMessage = '已添加了此银行卡，请不要重复添加'
            else {
              this.errBankMessage = ''
              this.getBankName(number)
            }
          }
        }
      })
    },
    getBankName(number) {
      api.getBankByCardNumber(number).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data.egpayBankCode) {
              this.egpayBankCode = JSON.parse(JSON.stringify(res.data.data.egpayBankCode))
              this.bankCode = JSON.parse(JSON.stringify(res.data.data.egpayBankCode))
              this.selectBank(2)
            }
          }
        }
      })
    },
    selectBank(type, val) {
      this.$bus.$emit('loading', false)
      const arrName = []; const arrCode = []
      const data = 'listBankList'
      api.getDictInfo(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.bankList = res.data.data.listBankList
            if (type == 0) {
              for (const i in this.bankList) {
                const arrData = this.bankList[i]
                arrName.push(arrData.nameCN)
                arrCode.push(arrData.code)
              }
              this.list = arrName
              this.codeList = arrCode
              // this.show = true
              for (let i = 0; i < this.list.length; i++) {
                this.selectWithSearchList = [
                  ...this.selectWithSearchList,
                  {
                    key: this.codeList[i],
                    title: this.list[i]
                  }
                ]
              }
              this.showSelectWithSearch = true
              this.type = val
            } else if (type == 1) {
              this.toggleFixed()
              this.isHoldBank = true
            } else if (type == 2) {
              for (const i in this.bankList) {
                if (this.egpayBankCode == this.bankList[i].code) {
                  this.bankInfo.name = this.bankList[i].nameCN
                }
              }
            }
          }
        }
      })
    },
    selectCountry(val) {
      this.type = val
      this.getCountry()
      this.show = true
    },
    getCountry() {
      this.$bus.$emit('loading', false)
      const arrName = []; const arrCode = []
      api.getCountry().then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            const countryList = res.data.data.countryList
            for (const i in countryList) {
              const arrData = countryList[i]
              arrName.push(arrData.nameCN)
              arrCode.push(arrData.code)
            }
            this.list = arrName
            this.codeList = arrCode
          }
        }
      })
    },
    selectProvince(val) {
      this.type = val
      this.getProvinces(this.countryCode)
      this.show = true
    },
    getProvinces(code, type) { // 0表示省市联动
      this.$bus.$emit('loading', false)
      const arrName = []; const arrEng = []
      api.getProvincesByCountry(code).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            const provinceList = res.data.data.provinceList
            for (const i in provinceList) {
              const arrData = i
              arrEng.push(arrData)
              arrName.push(provinceList[i])
            }
            this.list = arrName
            this.codeList = arrEng
            if (type == 0) {
              this.bankInfo.province = this.list[0]
              this.provinceCode = this.codeList[0]
              if (code == 'other') this.provinceCode = 'other'
              this.getCities(this.provinceCode, 0)
            }
          }
        }
      })
    },
    selectCity(val) {
      this.type = val
      this.getCities(this.provinceCode)
      this.show = true
    },
    getCities(code, type) { // 0表示省市联动，1表示通过弹窗
      this.$bus.$emit('loading', false)
      const arrName = []; const arrCode = []
      api.getCitiesByProvince(code).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            const cityList = res.data.data.cityList
            for (const i in cityList) {
              arrName.push(cityList[i])
              arrCode.push(i)
            }
            this.list = arrName
            this.codeList = arrCode
            if (type == 0) {
              this.bankInfo.city = this.list[0]
              this.cityCode = this.codeList[0]
            }
          }
        }
      })
    },
    change(data) {
      if (this.type == 'bankType') {
        this.bankInfo.name = data.name
        this.bankCode = data.code
      }
      if (this.type == 'countryType') {
        this.countryCode = data.code
        if (data.code == 'other') this.provinceCode = 'other'
        this.bankInfo.country = data.name
        this.getProvinces(this.countryCode, 0)
      }
      if (this.type == 'provinceType') {
        this.provinceCode = data.code
        if (this.countryCode == 'other') this.provinceCode = 'other'
        this.bankInfo.province = data.name
        this.getCities(this.provinceCode, 0)

        this.isInvalidBankAndProv()
      }
      if (this.type == 'cityType') {
        this.cityCode = data.code
        if (this.provinceCode == 'other') {
          this.cityCode = ''
          this.bankInfo.city = ''
        } else this.bankInfo.city = data.name
      }
    },
    cancel(show) {
      this.show = show
    },
    closeHoldBankPop(show) {
      this.isHoldBank = show
    },
    withdrawBankList() {
      api.getWithdrawBankList().then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data.withdrawBankList) {
              this.bankOrderNum(res.data.data.withdrawBankList)
            }
          }
        }
      })
    },
    bankOrderNum(data) {
      const approvedBankCards = data.filter(card => card.approveStatus == "APPROVAL")
      if (approvedBankCards.length < 3) {                        
            var arr1 = [1, 2, 3]
            var arr2 = Array()
         if (data && data.length > 0) {
        for (let j = 0; j < data.length; j++) {
          arr2.push(data[j].bankOrder)
        }
      }
      const newArray = arr1.concat(arr2).filter(function(v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v)
      })
      this.bankOrder = newArray[0]
      }
    },
    LabelAuthority() {
      api.getLabelAuthority().then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            const data = res.data.data
            this.verifyThreeElement = data.verifyThreeElement
            this.bankCardFourElement = data.bankCardFourElement
          }
        }
      })
    },
    goNextRecharge() {
      const readyData = this.$qs.stringify(this.bankParam)
      api.addDepositBank(readyData).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            const withdrawBankOrder = res.data.data.withdrawBankOrder
            this.errMessage = ''
            this.setForeBase()
            this.$router.replace({
              path: '/home/success',
              query: { type: 0, withdrawBankOrder: withdrawBankOrder }
            })
          } else {
            this.$bus.$emit('loading', true)
            this.errMessage = res.data.code_desc
          }
        }
      })
    },
    goNextWithdrawal() {
      const readyData = this.$qs.stringify(this.bankParam)
      api.addWithdrawBank(readyData).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.errMessage = ''
            this.$router.push({ path: '/home/uploadProof', query: { bankOrder: this.bankOrder }})
          } else {
            this.$bus.$emit('loading', true)
            this.errMessage = res.data.code_desc
          }
        }
      })
    },
    verifyBank() {
      const verifyBankData = this.$qs.stringify(this.verifyBankParam)
      api.verifyBankElement(verifyBankData).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data.flag == 1) {
              this.setForeBase()
              if (this.bankType == 1) this.goNextRecharge()
              else this.goNextWithdrawal()
            } else if (res.data.data.flag == 2 || res.data.data.flag == 4) {
              this.$bus.$emit('loading', true)
              this.toggleFixed()
              this.isBankInfoErr = true
              this.bankInfoErrFlag = 0
              this.bankInfoErr = '所绑定的银行卡与当前用户信息不匹配，请重新填写'
            } else if (res.data.data.flag == 3) {
              this.$bus.$emit('loading', true)
              this.toggleFixed()
              this.isBankInfoErr = true
              this.bankInfoErrFlag = 1
              this.bankInfoErr = '网络异常，请刷新重试'
            }
          }
        }
      })
    },
    submit() {
      if (this.isInvalidBankAndProv()) {
        return
      }
      
      if (utils.isNotEmpty(this.bankInfo.number) && utils.isNotEmpty(this.bankInfo.name) && this.bankInfo.name != '请选择银行' && utils.isNotEmpty(this.bankInfo.country) && ((this.bankType == 0 || this.bankType == '') ? utils.isNotEmpty(this.bankInfo.code) : this.bankCardFourElement ? utils.isNotEmpty(this.bankInfo.code) : utils.isEmpty(this.bankInfo.code))) {
        this.$bus.$emit('loading', false)
        if (this.bankType == 1) {
          if (this.verifyThreeElement || this.bankCardFourElement) {
            this.verifyBank()
          } else {
            this.goNextRecharge()
          }
        } else this.verifyBank()
      }
    },
    onMouseOver() {
      if (this.pageType == 'app') document.getElementById('layout').style.paddingBottom = '3.39rem'
    },
    onMouseOut() {
      if (this.pageType == 'app') document.getElementById('layout').style.paddingBottom = '0'
    },
    hideSelectWithSearch() {
      this.showSelectWithSearch = false
      this.selectWithSearchList = [] // Clear select list or else will be duplicated on subsequent loadings
    },
    confirmSelectWithSearch(item) {
      this.hideSelectWithSearch()
      this.bankInfo.name = item.title
      this.bankCode = item.key
      
      this.isInvalidBankAndProv()
    },
    isInvalidBankAndProv() {
      if (this.bankInfo.name.includes('工商银行')) {
        if(this.bankInfo.province.includes('广东')){
          this.showWarningPop = true
          return true
        }else{
          this.showWarningOtherCitiesPop = true
        }
      }
      return false
    },
    isOptional() {
      const bankName = this.bankInfo.name;
      return !(bankName.includes('商业') || bankName.includes('农商') || bankName.includes('农村商业'));
    },
    onBankInfoNumberInput(e) {
      let value = e.target.value

      // 1. Always remove spaces and zero-width characters first
      value = value.replace(/\s+/g, '').replace(/\u200B/g, '')

      // 2. If it is NOT Alipay, strictly remove non-digits
      if (this.bankInfo.name !== '支付宝') {
        value = value.replace(/[^\d]/g, '')
      }

      // 3. Force update the DOM input and the data model
      // This ensures invalid characters don't appear even for a split second
      e.target.value = value
      this.bankInfo.number = value
    },  
  }
}
</script>
